/* MUI */
import { Box, Card, CardContent, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

/* Components */
import { CurrencyValue } from './CurrencyValue';

export const KPICard = ({
    backgroundColor,
    bigNumber,
    number,
    numberIsCurrency,
    subtitle,
    textColor,
    title
}) => {
    const numberNumber = parseFloat(number);

    return (
        <Card
            elevation={0}
            style={{
                backgroundColor,
                height: '100%'
            }}
            data-testid="kpiCard"
        >
            <CardContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    paddingBottom: '12px',
                    paddingTop: '12px'
                }}
            >
                {Number.isFinite(numberNumber) && !numberIsCurrency && (
                    <Typography
                        data-testid="kpiNumberNotCurrency"
                        variant="p"
                        sx={{
                            color: textColor,
                            fontSize: bigNumber ? FontSizes[5] : FontSizes[4]
                        }}
                    >
                        {numberNumber}
                    </Typography>
                )}
                {Number.isFinite(numberNumber) && numberIsCurrency && (
                    <CurrencyValue textColor={textColor} value={numberNumber} />
                )}
                {title && (
                    <Typography
                        data-testid="kpiTitle"
                        variant="p"
                        sx={{
                            color: textColor,
                            fontSize: FontSizes[2],
                            marginTop: '4px'
                        }}
                    >
                        {title}
                    </Typography>
                )}
                {subtitle && (
                    <Box mt="8px" data-testid="kpiSubtitle">
                        {subtitle}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};
